import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Paper, Input, NativeSelect, InputBase, Button } from '@material-ui/core'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useSelector } from 'react-redux'

import Header from '../../../../layout/Header'
import Subheader from '../../../../layout/Subheader'
import Loading from '../../../../components/Loading'

import { formatDateTimeToRender } from '../../../../utils/functions'

import useStyles from './style'

function Render ({
  inputs,
  handleInputChange,
  getErros,
  setErros,
  getLoading,
  onSubmit
}) {
  const classes = useStyles()
  const { lastAnchorStore } = useSelector(state => state.anchors)

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title={`Editando código da Loja: ${lastAnchorStore} da rede: `} submit={onSubmit} loading={getLoading} submitText="Atualizar" back={false} subanchor={true} />
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {getLoading
            ? (<Loading />)
            : (
            <form onSubmit={onSubmit}>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Informações</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={6}>

                  <label className={classes.label}>Código Interno</label>
                  <Paper className={classes.large} elevation={0}>
                  <Input
                      style={{ textTransform: 'uppercase !important' }}
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Código Interno"
                      value={inputs.codigoInterno}
                      name="codigoInterno"
                      onBlur={event => getErros.includes('CodigoInterno') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'CodigoInterno'
                        })
                      )}
                      error={getErros.includes('CodigoInterno')}
                      onChange={handleInputChange}
                      autoComplete="off"
                      inputProps={{
                        maxLength: 20
                      }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                <label className={classes.label}>Status</label>
                  <Paper className={classes.medium} elevation={0}>
                  <NativeSelect
                      className={classes.input}
                      value={inputs.status}
                      name="status"
                      onChange={handleInputChange}
                      error={getErros.includes('Status')}
                      onBlur={event => getErros.includes('Status') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'Status'
                        })
                      )}
                    >
                      <option value="Ativo">Ativo</option>
                      <option value="Inativo">Inativo</option>
                    </NativeSelect>
                  </Paper>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
<AccordionSummary
  expandIcon={<ExpandMoreIcon />}
  aria-controls="panel1a-content"
  id="panel1a-header"
  className={classes.summary}
>
  <Typography className={classes.heading}>Dados do Registro</Typography>
</AccordionSummary>
<AccordionDetails className={classes.details}>
  <Grid container>

  <Grid item xs={6}>
                  <label className={classes.label}>Data de Registro</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)}
                      readOnly
                      placeholder="Data do Registro"
                    />
                  </Paper>
                </Grid>

                <Grid item xs={6}>
                  <label className={classes.label}>Data da Atualização</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataAtualizacao ? formatDateTimeToRender(inputs.dataAtualizacao) : ''}
                      readOnly
                      placeholder="Data da Atualização"
                    />
                  </Paper>
                </Grid>

  </Grid>
</AccordionDetails>
</Accordion>

          <div className={classes.divButton}>
            <Button variant="contained" type="submit" className={classes.button}>Atualizar</Button>
          </div>
          </form>

              )}
        </div>

      </div>
    </div>
  )
}

export default Render
